$(document).ready(function(){ 

  $('.toggle_search').on('click', (function (e) {
    $('.search-bar').removeClass('hide');
    $('.search-bar').toggle();
    e.stopPropagation();
    $('.user_account').hide();
  }));
  $('.search-bar').on('click', (function (e) {
    e.stopPropagation();
  })); 



  $('.user_logout svg').on("click", function (e) {
    $('.user_account').slideToggle();
    $('.site-header  .search-bar').hide(); 
    e.preventDefault();
    e.stopPropagation();
  });
  $(".menu_arrow").on("click", function () {
    $(this).siblings("ul").slideToggle();
    $(this).toggleClass('open');
    $(this).parent(".mobile-nav li ").siblings().children("ul").hide();
    $(this).parents('.mobile-nav li').siblings().children('span').removeClass('open');

    $(this).siblings('ul').children('li').children('ul').hide();
    $(this).siblings('ul').children('li').children('span').removeClass('open');
  });
  $('.menu_toggle').on('click',function(){
    $('body').toggleClass('nav-drawer-open');   
  });
  $('.nav_right_overlay,.menu_remove').on('click',function(){
    $('body').removeClass('nav-drawer-open');   
  });
  $('.site-nav--dropdown li').each(function(){
    if($(this).hasClass('site-nav--active')){
      $(this).parents('.site-nav--has-dropdown').addClass('site-nav--active');
    } 
  });

  $('.mobile-nav--dropdown li').each(function(){
    if($(this).hasClass('mobile-nav--active')){
      $(this).parents('.mobile-nav--has-dropdown').addClass('mobile-nav--active');
    } 
  });

  $('.product-photo-thumbs').slick({
    infinite: true,
    arrows:true,
    slidesToShow: 3,   
    focusOnSelect: true,
    slidesToScroll: 1,
    infinite: false,
  });

  $('.arrival_slider').slick({
    infinite: true,
    arrows:true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1       
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1       
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1       
        }
      }
    ]
  });

  $('.quotes-slider').slick({
    infinite: true,
    arrows:true,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1       
        }
      }    
    ]
  });


  $('.featured_product_slider').slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: false,

    infinite: false,
    arrows:true,
    responsive: [      
      {
        breakpoint: 991,
        settings: {        
          slidesToShow: 2
        }
      },
      {
        breakpoint: 620,
        settings: {        
          slidesToShow: 1
        }
      }
    ]
  });

  $(".quantity_selector").append('<div class="inc button"><span>+</span></div><div class="dec button"><span>-</span></div>');
  $(".button").on("click", function () {
    var $button = $(this);
    var oldValue = $button.parent().find("input").val();
    if (oldValue === "") {
      oldValue = 0;
    }
    if ($button.text() === "+") {
      var newVal = parseFloat(oldValue) + 1;
    } else {
      // Don't allow decrementing below zero
      if (oldValue > 0) {
        var newVal = parseFloat(oldValue) - 1;
      } else {
        newVal = 0;
      }
    }
    $button.parent().find("input").val(newVal);
  });

  $(document).on('click', '.filter_menu a', function () {
    $('.collection_sidebar').animate({left: '0'});
    $('body').addClass('collection-filter');
  });
  $('.filter_colse,.filter-overlay').on("click", function () {
    var collection_sidebar = $('.collection_sidebar').outerWidth();
    $('.collection_sidebar').animate({left: -collection_sidebar});
    $('body').removeClass('collection-filter');
  });

  setTimeout(function(){



    $(' ul#sortBy li').each(function(){ 
      if($(this).children().hasClass('active')){
        $(this).parent().show();
        $(this).parent().prev().addClass("open-filter");
      }      
    });

    $('ul.advanced-filters li').each(function(){
      if($(this).hasClass('site-nav--active')){
        $(this).parent().show();
        $(this).parent().prev().addClass("open-filter");
      }
      if($(this).hasClass('active-filter')){
        $(this).parent().show();
        $(this).parent().prev().addClass("open-filter");
      }
    });
  }, 1000);
});

$.fn.equalHeights = function(){
  var max_height = 0;
  $(this).each(function(){
    max_height = Math.max($(this).height(), max_height);
  });
  $(this).each(function(){
    $(this).height(max_height);
  });
};

$(document).ready(function(){
  $('.quotes-slider__text').equalHeights();
});
$(document).ready(function() {
  $('ul.product-photo-thumbs li a').click(function() {
    $('li a.active').removeClass("active");
    $(this).addClass("active");
  });


  $('.shop_dropdown  .site-nav--dropdown-grandchild li').each(function(){  
    var l_path = location.pathname;
    var l_path = location.pathname.split('/price')[0];
    var a_href = $(this).children().attr('href');
    if(a_href == l_path ){          
      $('.category_list ul').html($(this).parent().html());
    }        
  });

  if($('.banner_img').hasClass('block_banner')){
  $('.default_show_banner').hide();
  }
//   setTimeout(function(){ 
//   $('.single-option-selector option').each(function(){
//     var o_hide = $(this).val();
//     if(o_hide == 'Default Title'){
//       $(this).parent().hide();
//     }
//   });
//                          }, 1000);

});